'use strict';

/**
 * Базовый класс для работы с элементами формы маркетплейса
 */
class MarketplaceFormComponent {
    /**
     * @param {string|jQuery} selector - CSS-селектор или jQuery-объект
     */
    constructor(selector) {
        this.element = typeof selector === 'string' ? $(selector) : selector;
    }

    /**
     * Получение значения элемента
     * @returns {*} - Значение элемента
     */
    getValue() {
        return this.element.val();
    }

    /**
     * Установка значения элемента
     * @param {*} value - Значение для установки
     */
    setValue(value) {
        this.element.val(value);
        return this;
    }

    clear() {
        this.setValue('');
        return this;
    }

    /**
     * Блокировка/разблокировка элемента
     * @param {boolean} isDisabled - Флаг блокировки
     */
    setDisabled(isDisabled) {
        this.element.prop('disabled', isDisabled);
        return this;
    }
}

